import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const JoinRoomPage = () => {
  const [roomCode, setRoomCode] = useState('');
  const [playerName, setPlayerName] = useState('');
  const navigate = useNavigate();

  const joinRoom = async () => {
    const response = await fetch('https://quizbk.shirazkhan.me/join-room', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ roomCode, playerName })
    });

    const data = await response.json();

    if (response.ok) {
      // Store player ID and room code locally
      localStorage.setItem('playerId', data.playerId);
      localStorage.setItem('roomCode', roomCode);
      localStorage.setItem('playerName', playerName);

      // Navigate to the quiz page
      navigate(`/quiz/${roomCode}`);
    } else {
      alert(data.error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-400 to-indigo-500 flex flex-col items-center justify-center p-4">
      <h1 className="text-4xl font-bold text-white mb-6">Join Room</h1>
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-6">
        <input
          type="text"
          value={playerName}
          onChange={(e) => setPlayerName(e.target.value)}
          placeholder="Enter your name"
          className="w-full p-3 border rounded-lg mb-4"
        />
        <input
          type="text"
          value={roomCode}
          onChange={(e) => setRoomCode(e.target.value)}
          placeholder="Enter room code"
          className="w-full p-3 border rounded-lg mb-6"
        />
        <button
          onClick={joinRoom}
          className="w-full px-6 py-3 bg-green-500 hover:bg-green-600 text-white font-bold rounded-lg shadow-lg"
        >
          Join Room
        </button>
      </div>
    </div>
  );
};

export default JoinRoomPage;